import { Component, OnInit,
         Output,
         EventEmitter,
         ElementRef } from '@angular/core';

// By importing just the rxjs operators we need, We're theoretically able
// to reduce our build size vs. importing all of them.
import { Observable } from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/switch';

import { Artikel } from '../models/artikel.model';
import { ArtikelService } from '../services/artikel.service';

import { Lagerplatz } from '../models/lagerplatz.model';
import { LagerplatzService } from '../services/lagerplatz.service';

@Component({
  selector: 'sws-artikelsuche',
  templateUrl: './artikelsuche.component.html',
  styleUrls: ['./artikelsuche.component.css']
})
export class ArtikelsucheComponent implements OnInit {
  loading: boolean;
  sucheUeber: string;
  vergleich: string;
  suchbegriff: string;
  top: string; 
  mitBestand = true;
  ueberArtbez = false;
  anzahlArt:string = '25';

  anzahlAuswahl = [
    {value: '25', viewValue: '25 Artikel'},
    {value: '50', viewValue: '50 Artikel'},
    {value: '100', viewValue: '100 Artikel'},
    {value: '250', viewValue: '250 Artikel'}
  ];

  // gelesene Artikel ----------------------
  artListe: Artikel[] = [];

  // gelesene Lagerplätze ----------------------
  lpArtListe: Lagerplatz[] = [];
  
  // Merker ob Artikel-Lagerplatzliste aktive ist
  // Wenn nein, die normale Lagerplatzliste
  private lpArtlisteAnz: boolean;

  errorMessage: string;

  private anyErrors: boolean;
  private finished: boolean;

  // für Artikelliste
  @Output() results: EventEmitter<Artikel[]> = new EventEmitter<Artikel[]>();
  // für Lagerplatzliste
  @Output() lpArtikelAnz: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() lpLPlatzresults: EventEmitter<Lagerplatz[]> = new EventEmitter<Lagerplatz[]>();
 
 
  constructor(private artSuche: ArtikelService,
              private lpSuche: LagerplatzService,
              private el: ElementRef) {
    console.log("Constructor in artikelsuche!");

    this.results = new EventEmitter();
    this.lpArtikelAnz = new EventEmitter();
    this.lpLPlatzresults = new EventEmitter();

  }

  ngOnInit(): void {
    console.log("ngOnInit in artikelsuche!");

    // Wenn Artikelliste im Suchservice vorhanden ist, dann ging der Benutzer im Browser zurück
    // diese Liste erneut laden
    if ( this.artSuche.artikelStore )
      {
        if ( this.artSuche.artikelStore.length > 0 )
          {
            this.artListe = this.artSuche.artikelStore;
            this.results.emit(this.artListe);
          }
      }
 
  }

  // Artikel suchen entsprechend der Auswahl --------------------------------------
  suchen(): void {
    this.lpArtlisteAnz = true ;
    this.lpArtikelAnz.emit(this.lpArtlisteAnz);
    this.loading = true;
    console.log('Suchbegriff = ' + this.suchbegriff);
    this.top = '20';
    if ( this.ueberArtbez == false)  {
        // Artikelnummer >=
         this.sucheUeber = 'ATArtikelnummer';
         this.vergleich = 'ge';  // greater or equal
      }
    else {
        // Bezeichnung1 enthält
         this.sucheUeber = 'ATBezeichnung1';
         this.vergleich = 'contains';  // enthält
    }
    // Anzahl Artikel
    this.top = this.anzahlArt;
     
    // im ArtikelService lesen --------------------------------------------------
    this.artSuche.getArtikelliste(this.sucheUeber, this.vergleich,this.suchbegriff,this.top, this.mitBestand)
                                            .subscribe(
                                               artData => { 
                                                 this.artListe = artData;
                                                 this.results.emit(this.artListe);
                                                 },
                                               error => this.errorMessage = <any>error
                                              );
    
    this.loading = false;
  }

  // Artikel mit Lagerplatzinhalt suchen entsprechend der Auswahl --------------------------------------
  lagerplatzliste(): void {
    this.lpArtlisteAnz = false ;
    this.lpArtikelAnz.emit(this.lpArtlisteAnz);
    
    this.artSuche.artikelStore = [];

    this.loading = true;
    console.log('Suchbegriff = ' + this.suchbegriff);
    this.top = '1000';
    if ( this.ueberArtbez == false)  {
        // Artikelnummer >=
         this.sucheUeber = 'LSI_Artikelnummer';
         this.vergleich = 'ge';  // greater or equal
      }
    else {
        // Bezeichnung1 enthält
         this.sucheUeber = 'AT_Bezeichnung1';
         this.vergleich = 'contains';  // enthält
    }
    // Anzahl Artikel
    this.top = this.anzahlArt;
     
    // imLagerplatzservice lesen --------------------------------------------------
    this.lpSuche.getAlleLagerplatzliste(this.sucheUeber, this.vergleich,this.suchbegriff,this.top)
                                            .subscribe(
                                              lpartData => { 
                                                 this.lpArtListe = lpartData;
                                                 this.lpLPlatzresults.emit(this.lpArtListe);
                                                 },
                                               error => this.errorMessage = <any>error
                                              );
    
    this.loading = false;

  }
  
  protokoll(): void {
    console.log('Anzahl Artikel in artListe = ' + this.artListe.length);
    console.log('Anzahl Artikel in artikelStore = ' + this.artSuche.artikelStore.length);
    console.log('Anzahl Artikel in artikelStore2 = ' + this.artSuche.artikelStore2.length);
    console.log('Anzahl Lagerplätze in LagerplatzListe = ' + this.lpArtListe.length);
  }

    
}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/artikelsuche/artikelsuche.component.ts